<template>
  <div
    class="rec-list-wrap"
    :class="{variable}"
  >
    <Waypoint
      v-if="slug && slug.length"
      :key="key"
      :tag="'div'"
      :active="!filterSelected"
      class="rec-list-line slug-line"
      :options="intersectionOptions"
      @change="onWaypoint"
      @mousedown.stop="() => true"
    >
      <div class="rec-element">
        <div
          v-for="(el, i) in slug"
          :key="`slel-${i}`"
          :class="{translate: translate}"
          class="rec-list-name slug"
        >
          {{ el }}
        </div>
      </div>
      <div
        v-if="!multiselect && !disableAdding"
        class="rec-button clickable not-translate"
        :title="addElementTitle"
        @click.stop="$emit('addElement', parentIds)"
        @mousedown.stop="() => true"
      >
        <FontAwesomeIcon icon="plus" />
      </div>
    </Waypoint>
    <div
      v-if="companyCustom"
      class="rec-list-line"
      @mousedown.stop="$emit('customSelect', [...parentIds, id])"
    >
      <div class="rec-element">
        <div
          class="rec-list-name company-custom"
          :class="{translate: translate}"
          :style="{
            'padding-left': `${parent.length * 20}px`,
          }"
        >
          <i class="fi fi-firm" />
          {{ name }}
        </div>
      </div>
    </div>
    <Waypoint
      v-else-if="name"
      v-show="
        (!filter && !filterSelected && !selectDeepest) ||
        showName(name, parent, id)
      "
      :key="key + 10000"
      :tag="'div'"
      :active="!filterSelected"
      class="rec-list-line"
      :class="{
        'light-hover': param && (param.inactive || param.clickableIcon),
        'slug-line':
          (deepest && list && list.length && !forecastEnabledOnly) ||
          (forecastEnabledOnly && !forecastEnabled),
      }"
      :options="intersectionOptions"
      @change="onWaypoint"
      @mousedown.stop="
        (!param || (!param.inactive && !param.clickableIcon)) &&
        !(
          (deepest && list && list.length && !forecastEnabledOnly) ||
          (forecastEnabledOnly && !forecastEnabled)
        )
          ? param && param.selectAll
            ? selectAll()
            : $emit('select', multiselect ? id : [...parentIds, id])
          : () => true
      "
    >
      <div class="rec-element">
        <div
          v-if="showPath && parent && parent.length"
          class="rec-list-parent"
        >
          {{ parent.join(' > ') }}
        </div>
        <div
          class="rec-list-name"
          :class="{
            'text-gray': param && (param.inactive || param.clickableIcon),
            slug:
              (deepest && list && list.length && !forecastEnabledOnly) ||
              (forecastEnabledOnly && !forecastEnabled),
            translate: translate,
          }"
          :style="{
            'padding-left': `${parent.length * 20}px`,
          }"
        >
          <div
            v-if="param && param.line"
            class="example-line"
          >
            <div
              class="line"
              :style="{'background-color': param.line}"
            />
          </div>
          <div
            v-if="showLogo"
            class="bank-logo not-translate"
            :style="{
              'background-color': stringToHslColor(name, 50, 60),
            }"
          >
            <span class="slg"> {{ nameToSlug(name) }}</span>
          </div>
          <span class="name">{{ name }}</span>
        </div>
      </div>
      <div
        v-if="
          !multiselect &&
          !disableAdding &&
          (!maxLevel || maxLevel - 1 > parent.length) &&
          (!onlyAlterable || alterable) &&
          (forecastEnabledOnly && id
            ? (forecastEnabled && list.length === 0) ||
              (!forecastEnabled && list.length !== 0)
            : true)
        "
        class="rec-button clickable not-translate"
        :title="addElementTitleAlterable"
        @click.stop="$emit('addElement', multiselect ? id : [...parentIds, id])"
        @mousedown.stop="() => true"
      >
        <FontAwesomeIcon icon="plus" />
      </div>
      <div
        v-if="
          multiselect && (!param || (!param.inactive && !param.clickableIcon))
        "
        class="rec-selector"
      >
        <Checkbox
          :style="{width: '14px'}"
          :value="
            param && param.selectAll ? selectedAll : selected.includes(id)
          "
          no-tip
          @click.stop="() => true"
          @fygr-toggle="
            param && param.selectAll ? selectAll() : $emit('select', id)
          "
        />
      </div>
      <div
        v-else-if="param && param.clickableIcon"
        class="rec-selector translate"
        :title="param.title"
        @click.stop="$emit('icon', {id, icon: param.clickableIcon})"
      >
        <FontAwesomeIcon :icon="param.clickableIcon" />
      </div>
    </Waypoint>
    <div
      v-if="
        list &&
        list.length &&
        (!maxSelectLevel || !parent || maxSelectLevel - 1 > parent.length) &&
        forecastEnabledOnly &&
        id
          ? !forecastEnabled
          : true
      "
      class="rec-list"
    >
      <RecursiveList
        v-for="(el, i) in list"
        :id="el.id"
        :key="`rec-${el.id}-${i}`"
        :ref="`rec-${el.id}`"
        :alterable="el.is_alterable"
        :company-custom="el.companyCustom"
        :deepest="deepest"
        :disable-adding="disableAdding || el.locked"
        :forecast-enabled="el.forecast_enabled"
        :forecast-enabled-only="forecastEnabledOnly"
        :list="el.list"
        :max-level="maxLevel"
        :max-select-level="maxSelectLevel"
        :multiselect="multiselect"
        :name="el.name"
        :param="el.param"
        :parent="parent && name ? [...parent, name] : []"
        :parent-ids="parentIds && id ? [...parentIds, id] : []"
        :parent-shown="showName(name, parent, id)"
        :filter="filter"
        :filter-selected="filterSelected"
        :min-displayed="minIdxDisplayed"
        :index="i"
        :only-alterable="onlyAlterable"
        :selected="selected"
        :stay-selected="staySelected"
        :select-deepest="selectDeepest"
        :slug-index="slugNeeded.indexOf(true)"
        :slug-list="slugList"
        :variable="variable"
        :translate="translate || el.forceTranslate"
        :force-translation-line="el.forceTranslationLine"
        :show-logo="el.showLogo"
        @add-element="$emit('addElement', $event)"
        @add-slug="$emit('addSlug', $event)"
        @hidden="$emit('hidden', $event)"
        @icon="$emit('icon', $event)"
        @select="$emit('select', $event)"
        @custom-select="$emit('customSelect', $event)"
        @slug="$emit('slug', $event)"
      />
    </div>
  </div>
</template>
<script>
import {Waypoint} from 'vue-waypoint';
import {mapActions} from 'vuex';
import {formatMixin} from '@/mixins/formatMixin';

export default {
  name: 'RecursiveList',
  components: {
    Waypoint,
  },
  mixins: [formatMixin],
  props: {
    showLogo: Boolean,
    alterable: Boolean,
    companyCustom: Boolean,
    deepest: Boolean,
    disableAdding: Boolean,
    filter: {
      type: String,
      default: '',
    },
    filterSelected: Boolean,
    forecastEnabled: Boolean,
    forecastEnabledOnly: Boolean,
    id: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
    maxLevel: {
      type: Number,
      default: null,
    },
    maxSelectLevel: {
      type: Number,
      default: null,
    },
    multiselect: Boolean,
    name: {
      type: String,
      default: '',
    },
    parent: {
      type: [Array, null],
      default: null,
    },
    parentIds: {
      type: Array,
      default: () => [],
    },
    preselected: {
      type: Array,
      default: () => [],
    },
    index: {
      type: Number,
      default: null,
    },
    minDisplayed: {
      type: Number,
      default: null,
    },
    param: {
      type: Object,
      default: () => {},
    },
    onlyAlterable: Boolean,
    parentShown: Boolean,
    selected: {
      type: Array,
      default: () => [],
    },
    staySelected: {
      type: Array,
      default: () => [],
    },
    selectDeepest: Boolean,
    showPath: Boolean,
    slugList: {
      type: Array,
      default: () => [],
    },
    slugIndex: {
      type: Number,
      default: null,
    },
    variable: Boolean,
    translate: {
      type: Boolean,
      default: false,
    },
    forceTranslationLine: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'slug',
    'hidden',
    'addSlug',
    'icon',
    'select',
    'customSelect',
    'addElement',
  ],
  data() {
    return {
      key: 0,
      listOpened: true,
      hidden: false,
      firstHidden: false,
      intersectionOptions: {
        root: null,
        rootMargin: '50px 0px 0px 0px',
        threshold: [1],
      },
      slug: null,
      addElementTitleText: 'Ajouter un élément dans',
    };
  },
  computed: {
    addElementTitle() {
      return `${this.addElementTitleText} '${[...this.slug].splice(-1, 1)}'`;
    },
    addElementTitleAlterable() {
      return `${this.addElementTitleText} '${this.name}'`;
    },
    slugNeeded() {
      return this.list.map((el) =>
        this.showName(
          el.name,
          this.parent && this.name ? [...this.parent, this.name] : [],
          el.id,
        ),
      );
    },
    minIdxDisplayed() {
      let min = null;
      if (!this.list) {
        return -1;
      }
      this.list.reduce((acc, el) => {
        if (
          this.showName(
            el.name,
            this.parent && this.name ? [...this.parent, this.name] : [],
            el.id,
          ) &&
          min === null
        ) {
          min = acc;
        }
        return acc + 1;
      }, 0);
      return min === null ? -1 : min;
    },
    selectedAll() {
      const isSelected = this.list.map((el) => {
        const refs =
          this.$refs[`rec-${el.id}`] &&
          this.$refs[`rec-${el.id}`][0] &&
          this.$refs[`rec-${el.id}`][0].selectedAll;
        return this.selected.includes(el.id) || !!refs;
      });
      return !isSelected.includes(false) && this.param && this.param.selectAll;
    },
  },
  watch: {
    filter() {
      if (this.filterSelected) {
        this.checkSlug();
      } else {
        this.resetSlug();
      }
    },
    index() {
      if (this.filterSelected) {
        this.checkSlug();
      } else {
        this.resetSlug();
      }
    },
    selected: {
      handler() {
        this.key += 1;
        this.checkSlug();
      },
      deep: true,
    },
    filterSelected() {
      this.checkSlug();
    },
  },
  async mounted() {
    if (
      this.selectDeepest &&
      this.maxLevel &&
      this.parent &&
      this.index === this.slugIndex
    ) {
      if (this.maxLevel - 1 === this.parent.length) {
        this.getSlug();
      } else if (
        this.maxLevel - 1 > this.parent.length &&
        (!this.list || !this.list.length)
      ) {
        const inc = this.parent.map((el) =>
          el.toLowerCase().includes(this.filter.toLowerCase()),
        );
        if (inc.includes(true)) {
          this.slug = [...this.parent, this.name];
          this.$emit('slug', this.slug.join(' > '));
        }
      }
    }
    this.addElementTitleText = await this.actionTranslatePhrase(
      'Ajouter un élément dans',
    );
  },
  methods: {
    ...mapActions('translations', ['actionTranslatePhrase']),
    showName(name, parent, id) {
      let list = [];
      if (parent) {
        list = parent.map((el) => this.stringInclude(el, this.filter));
      }
      return (
        (!this.filterSelected || this.staySelected.includes(id)) &&
        ((this.filter &&
          (name ? this.stringInclude(name, this.filter) : true)) ||
          list.includes(true) ||
          (!this.filter && parent && parent.length === 0)) &&
        (!this.selectDeepest ||
          (this.selectDeepest &&
            this.maxLevel &&
            parent &&
            this.maxLevel - 1 === parent.length))
      );
    },
    getSlug() {
      if (
        (!this.filter && !this.selectDeepest) ||
        !this.showName(this.name, this.parent, this.id) ||
        this.parentShown
      ) {
        return;
      }
      let base = [];
      if (this.parent && this.parent.length) {
        for (let i = this.parent.length - 1; i >= 0; i -= 1) {
          if (
            this.filter &&
            !this.selectDeepest &&
            this.parent[i].toLowerCase().includes(this.filter.toLowerCase())
          ) {
            break;
          } else {
            base = [this.parent[i], ...base];
          }
        }
      }
      if (this.slugList.includes(base.join(' > '))) {
        return;
      }
      this.slug = [...base];
      this.$emit('slug', this.slug.join(' > '));
    },
    checkSlug() {
      if (!this.filterSelected) {
        return;
      }
      if (
        this.showName(this.name, this.parent, this.id) &&
        this.parentIds.filter((value) => this.selected.includes(value))
          .length === 0 &&
        this.index === this.minDisplayed
      ) {
        this.slug = [...this.parent];
        this.$emit('slug', this.slug.join(''));
      } else {
        this.$emit('hidden', null);
        this.slug = null;
      }
    },
    resetSlug() {
      this.slug = null;
      if (this.index === this.slugIndex) {
        if (this.selectDeepest && this.maxLevel && this.parent) {
          if (this.maxLevel - 1 === this.parent.length) {
            this.getSlug();
          } else if (
            this.maxLevel - 1 > this.parent.length &&
            (!this.list || !this.list.length)
          ) {
            const inc = this.parent.map((el) =>
              el.toLowerCase().includes(this.filter.toLowerCase()),
            );
            if (inc.includes(true)) {
              this.slug = [...this.parent, this.name];
              this.$emit('slug', this.slug.join(' > '));
            }
          }
        } else if (this.parent && this.parent.length) {
          this.getSlug();
        }
      }
    },
    selectAll() {
      if (this.selectedAll) {
        this.list.map((el) => {
          this.$refs[`rec-${el.id}`][0].select(this.list && this.list.length);
          return null;
        });
      } else {
        this.list.map((el) => {
          if (
            !this.selected.includes(el.id) &&
            !this.$refs[`rec-${el.id}`][0].selectedAll
          ) {
            this.$refs[`rec-${el.id}`][0].select(this.list && this.list.length);
          }
          return null;
        });
      }
    },
    select(all = false) {
      if (!this.param || !this.param.selectAll) {
        this.$emit('select', this.id);
      } else if (all) {
        this.selectAll();
      }
    },
    onWaypoint({going, direction}) {
      if (going === 'OUT' && direction === 'UP') {
        this.hidden = true;
        if (!this.index) {
          this.firstHidden = true;
        }
        if (this.parent && this.parent.length) {
          this.$emit(
            'hidden',
            this.list && this.list.length
              ? [...this.parent, this.name]
              : this.parent,
          );
        } else {
          this.$emit('hidden', []);
        }
      }
      if (
        going === 'IN' &&
        direction === 'DOWN' &&
        (this.hidden || this.firstHidden)
      ) {
        if (
          this.parent &&
          this.parent.length &&
          (this.index || this.firstHidden)
        ) {
          this.$emit(
            'hidden',
            this.list && this.list.length
              ? [...this.parent, this.name]
              : this.parent,
          );
        } else {
          this.$emit('hidden', []);
        }
        if (this.firstHidden) {
          this.firstHidden = false;
        } else {
          this.hidden = false;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.rec-list-wrap.variable {
  .example-line {
    display: flex;
    align-items: center;
    width: var(--px15);
    margin-right: var(--px10);
    .line {
      width: 100%;
      height: var(--px2);
    }
  }
  .rec-list-line {
    display: flex;
    cursor: pointer;
    flex-direction: row;
    width: calc(100% - var(--px40));
    min-height: var(--px40);
    border-bottom: 1px solid var(--fygr-line);
    padding: var(--px5) var(--px20);
    font-size: var(--px14);
    &.slug-line {
      cursor: default;
    }
    &.light-hover {
      .rec-selector {
        color: var(--fygr-gray);
        cursor: pointer;
      }
      &:hover {
        cursor: default;
        background-color: var(--fygr-hover-solid);
        color: var(--fygr-text-fade);
        .rec-selector {
          color: var(--fygr-gray);
        }
      }
    }
    .rec-list-parent {
      display: flex;
      font-size: var(--px12);
      justify-self: flex-start;
      color: var(--fygr-text-fade);
    }
    .rec-list-name {
      display: flex;
      word-wrap: break-word;
      overflow-wrap: break-word;
      .name {
        line-height: var(--px22);
      }
      .bank-logo {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: var(--px25);
        width: var(--px25);
        height: var(--px25);
        font-size: var(--px10);
        line-height: var(--px10);
        color: white;
        text-transform: uppercase;
        border-radius: 50%;
        margin-right: var(--px10);
        margin-left: var(--px-7);
        user-select: none;
        .slg {
          height: var(--px8);
        }
      }
      &.company-custom {
        color: var(--fygr-aubergine-ink);
        i {
          display: flex;
          align-self: center;
          justify-self: center;
          margin-right: var(--px8);
        }
      }
      &.slug {
        font-size: var(--px12);
        color: var(--fygr-text-fade);
      }
    }
    .rec-element {
      display: flex;
      flex: 1;
      justify-content: space-between;
      align-items: center;
      max-width: var(--px270);
      margin-right: auto;
      font-size: var(--px14);
    }
    .rec-button {
      display: none;
      align-items: center;
      color: white;
    }
    .rec-selector {
      display: flex;
      align-items: center;
      margin-left: var(--px20);
    }
    &:hover {
      background: var(--aubergine);
      color: white;
      &.slug-line {
        background: var(--fygr-hover-solid);
        .rec-list-name.slug {
          color: var(--fygr-text-fade);
        }
        .rec-button {
          color: var(--fygr-aubergine-ink);
        }
      }
      .rec-button {
        display: flex;
      }
      .rec-list-parent {
        color: var(--fygr-gray);
      }
      .rec-list-name.slug {
        color: var(--fygr-gray);
      }
      .rec-list-name.company-custom {
        color: white;
      }
    }
  }
}
.example-line {
  display: flex;
  align-items: center;
  width: var(--px15);
  margin-right: var(--px10);
  .line {
    width: 100%;
    height: var(--px2);
  }
}
.rec-list-line {
  display: flex;
  cursor: pointer;
  flex-direction: row;
  width: calc(100% - var(--px40));
  min-height: var(--px50);
  border-bottom: var(--px1) solid var(--fygr-line);
  padding: 0 var(--px20);
  &.slug-line {
    cursor: default;
  }
  &.light-hover {
    .rec-selector {
      color: var(--fygr-gray);
      cursor: pointer;
    }
    &:hover {
      cursor: default;
      background-color: var(--fygr-hover-solid);
      color: var(--fygr-text-fade);
      .rec-selector {
        color: var(--fygr-gray);
      }
    }
  }
  .rec-list-parent {
    display: flex;
    font-size: var(--px12);
    justify-self: flex-start;
    color: var(--fygr-text-fade);
  }
  .rec-list-name {
    display: flex;
    word-wrap: break-word;
    overflow-wrap: break-word;
    &.company-custom {
      color: var(--fygr-aubergine-ink);
      i {
        display: flex;
        align-self: center;
        justify-self: center;
        margin-right: var(--px8);
      }
    }
    &.slug {
      font-size: var(--px12);
      color: var(--fygr-text-fade);
    }
  }
  .rec-element {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    max-width: var(--px270);
    margin-right: auto;
  }
  .rec-button {
    display: none;
    align-items: center;
    color: white;
  }
  .rec-selector {
    display: flex;
    align-items: center;
    margin-left: var(--px20);
  }
  &:hover {
    background: var(--aubergine);
    color: white;
    &.slug-line {
      background: var(--fygr-hover-solid);
      .rec-list-name.slug {
        color: var(--fygr-text-fade);
      }
      .rec-button {
        color: var(--fygr-aubergine-ink);
      }
    }
    .rec-button {
      display: flex;
    }
    .rec-list-parent {
      color: var(--fygr-gray);
    }
    .rec-list-name.slug {
      color: var(--fygr-gray);
    }
    .rec-list-name.company-custom {
      color: white;
    }
  }
}
</style>
